module.exports = __webpack_public_path__ + "media/banner-bg-video-2.ba366320.mp4";